module.exports = __webpack_public_path__ + "img/number-thumb-6.8bd2eef7.jpg";